import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_setup.error
    ? _c(
        "div",
        [
          _setup.loading
            ? _vm._l(5, function (i) {
                return _c(VSkeletonLoader, {
                  key: i,
                  staticClass: "nav-link-skeleton mb-4",
                  attrs: { type: "list-item" },
                })
              })
            : _setup.analyzesLink || _setup.navLinks?.length
            ? _c(
                VList,
                {
                  staticClass: "d-flex flex-column ga-2",
                  class: _vm.counterXSpaceClass,
                },
                [
                  _setup.analyzesLink
                    ? _c(
                        VListItem,
                        {
                          staticClass: "primary--text mb-2",
                          class: _vm.xSpaceClass,
                          on: {
                            click: function ($event) {
                              return _setup.handleClickAnalyzes(
                                _setup.analyzesLink
                              )
                            },
                          },
                        },
                        [
                          _c(
                            VListItemIcon,
                            { staticClass: "align-self-center my-0 mr-4" },
                            [
                              _c(
                                "div",
                                { staticClass: "success pa-2 rounded-lg" },
                                [
                                  _c(
                                    VIcon,
                                    { attrs: { color: "bg-gray-0" } },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(_setup.analyzesLink.icon) +
                                          "\n          "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(VListItemContent, [
                            _c("div", [
                              _c(
                                "div",
                                { staticClass: "text-subtitle-1 text--text" },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_setup.analyzesLink.title) +
                                      "\n          "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "text-body-2 text-secondary--text",
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_setup.analyzesLink.subtitle) +
                                      "\n          "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            VListItemIcon,
                            { staticClass: "align-self-center" },
                            [
                              _c(
                                VIcon,
                                { attrs: { color: "icon-secondary" } },
                                [
                                  _vm._v(
                                    "\n          ui-icon-arrow-right\n        "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_setup.navLinks, function (navLink, i) {
                    return _c(
                      VListItem,
                      {
                        key: i,
                        staticClass: "primary--text",
                        class: _vm.xSpaceClass,
                        attrs: { href: navLink.link },
                      },
                      [
                        _c(
                          VListItemIcon,
                          { staticClass: "align-self-center my-0 mr-4" },
                          [
                            _c(
                              "div",
                              { staticClass: "bg-primary pa-2 rounded-lg" },
                              [
                                _c(
                                  VIcon,
                                  { attrs: { color: "icon-secondary" } },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(navLink.icon) +
                                        "\n          "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(VListItemContent, [
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "text-body-1 text--text" },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(navLink.title) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "text-body-2 text-secondary--text",
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(navLink.subtitle) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          VListItemIcon,
                          { staticClass: "align-self-center" },
                          [
                            _c(
                              VIcon,
                              { attrs: { color: "icon-secondary" } },
                              [
                                _vm._v(
                                  "\n          ui-icon-arrow-right\n        "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                ],
                2
              )
            : [
                _vm._v(
                  "\n    Вы можете искать по фамилии врача,\n    названию клиники и услуге\n  "
                ),
              ],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }